"use strict";

import "bootstrap";
import {Header} from "/scripts/components/Header.js";
// import "/scripts/components/cardscontainer.js";
// import "/scripts/components/splittext.js";
// import "/scripts/components/cardsequence.js";
// import "/scripts/components/footer.js";

const header = new Header();

window.addEventListener("scroll", () => {
  requestAnimationFrame(header.handleScroll);
});

window.addEventListener("resize", () => {
  requestAnimationFrame(header.handleResize);
});
